<template>
  <section class="p-3">
    <div v-if="iframeSrc">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        width="100%"
        height="900"
        allowtransparency=""
      ></iframe>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'IFrameContainer',
  props: {
    dashboard: {
      type: Number,
      default: 5,
    },
    project: {
      type: String,
      default: 'skylineDynamics',
    },
    merchantUuid: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      getMetabaseReportURL: 'account/getMetabaseReportURL',
      getNewMetabaseReportURL: 'account/getNewMetabaseReportURL',
    }),
    iframeSrc () {
      return this.project !== 'skylineDynamics'
        ? this.getNewMetabaseReportURL
        : this.getMetabaseReportURL;
    },
  },
  methods: {
    ...mapMutations({
      setMetabaseDashboard: 'account/setMetabaseDashboard',
      setMerchentId: 'account/setMerchentId',
    }),
  },
  created () {
    this.setMetabaseDashboard(this.dashboard);
    if (this.merchantUuid) {
      this.setMerchentId(this.merchantUuid);
    }
  },
};
</script>
